var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('c-header'),_c('router-view'),_c('c-character'),_c('c-footer'),_c('back-top')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }